import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import styled from 'styled-components'

import { SingleDropdownSelect } from '../../../../../components/dashboard/TalentPool/DropdownSelect'

import axiosInstance from '../../../../../services/config/AxiosIntance'

import { setIndustry } from '../../../../../../src/store/actions/jobListingActions'

const Industry = () => {
  const dispatch = useDispatch()
  const [industryList, setIndustryList] = useState([])

  const { industry } = useSelector((state) => state.jobListing)

  useEffect(() => {
    axiosInstance.get('/industries').then((response) => {
      setIndustryList(response?.data?.result)
    })
  }, [])

  const handleIndustryChange = (e) => {
    dispatch(setIndustry(e.target.value))
  }

  return (
    <StyledJobListFilter>
      <SingleDropdownSelect
        name="industry"
        title="Industry"
        value={industry}
        onChange={handleIndustryChange}
        maxw="350px"
      >
        {industryList.map((item) => (
          <option key={item.id} value={item.id}>
            {item.name}
          </option>
        ))}
      </SingleDropdownSelect>
    </StyledJobListFilter>
  )
}

export default Industry

const StyledJobListFilter = styled.div`
  float: left;
  padding-right: 20px;
`
